export { default } from "./CopyIcon";
